import { render } from "./ImportProductosEspeciales.vue?vue&type=template&id=90ba1f80"
import script from "./ImportProductosEspeciales.vue?vue&type=script&lang=js"
export * from "./ImportProductosEspeciales.vue?vue&type=script&lang=js"

import "./ImportProductosEspeciales.vue?vue&type=style&index=0&id=90ba1f80&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__